import React, { Component } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { withTranslation } from "react-i18next";
import Layout from "components/Layout";
import { FiRefreshCcw } from "react-icons/fi";
import Loading from "components/Loading";
import MyPreferences from "components/Preferences";
import PreferenceEdit from "components/Preferences/PreferenceEditModal";
import { showModal, hideModal } from "actions/modalActions";
import * as workflowsActions from "actions/workflowsActions";
import * as employeesActions from "actions/employeesActions";
import * as shiftsActions from "actions/shiftsActions";
import { workflowsService } from "services";
import { wfStatus } from "services/workflowsService";
import Modal from "components/Modal";
import { isAdmin, isSupervisor } from "utils/utils";
import PlanNavigationTabs from "../components/Plans/PlanNavigationTabs";

class Preferences extends Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewPreferenceModal = this.openNewPreferenceModal.bind(this);
		this.openEditPreferenceModal = this.openEditPreferenceModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.handleCancelRequest = this.handleCancelRequest.bind(this);
		this.handleReopenRequest = this.handleReopenRequest.bind(this);
	}

	async componentDidMount() {
		if (isAdmin() || isSupervisor()) {
			await this.props.getSelectableEmployees();
		}

		this.getData();
	}

	async getData() {
		this.setState({ loading: true }); // loading

		await Promise.all([
			this.props.getEmployeePreferences(),
			this.props.getSelectableEmployees(),
			this.props.getAttendanceShifts(),
		]);
		this.setState({
			loading: false,
		});
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewPreferenceModal() {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("preferences.newPreference"),
				style: { width: "500px" },
				content: <PreferenceEdit handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditPreferenceModal(absence, disabled) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: disabled ? t("preferences.viewPreference") : t("preferences.editPreference"),
				style: { width: "500px" },
				content: (
					<PreferenceEdit
						absence={absence}
						disabled={disabled}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openAlertModal(message, title) {
		this.props.showModal(
			{
				open: true,
				title: title || "Error",
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	handleCancelRequest(absence) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("preferences.cancelPreference"),
				style: { width: "350px" },
				message: t("preferences.cancelConfirm"),
				deleteAction: () => this.confirmCancelRequest(absence),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	confirmCancelRequest = async (preference) => {
		preference.status = wfStatus.canceled;
		preference.shift_id = preference.shift.id;

		if (!this.state.isSubmit) {
			this.setState({ isSubmit: true });
			const response = await workflowsService.update(preference);
			this.setState({ isSubmit: false });

			// console.log(response);
			if (response.ok) {
				toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));

				this.props.getEmployeePreferences();
				this.closeModal();
			} else {
				if (
					response.errors !== undefined &&
					Object.keys(response.errors).length > 0
				) {
					let textError = response.errors[0].description;
					this.openAlertModal(textError, this.props.t("preferences.errorCancel"));
				} else {
					this.openAlertModal(this.props.t("common.errorGeneric"), this.props.t("preferences.errorCancel"));
				}
			}
		}
	};

	// reabrir preferencia
	handleReopenRequest(absence) {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("preferences.reopenPreference"),
				style: { width: "350px" },
				message: t("preferences.reopenConfirm"),
				deleteAction: () => this.confirmReopenRequest(absence),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	confirmReopenRequest = async (preference) => {
		preference.status = wfStatus.pending;
		preference.shift_id = preference.shift.id;
		this.openEditPreferenceModal(preference, false);

		if (!this.state.isSubmit) {
			this.setState({ isSubmit: true });
			const response = await workflowsService.update(preference);
			this.setState({ isSubmit: false });

			// console.log(response);
			if (response.ok) {
				toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));

				this.props.getEmployeePreferences();
				this.openEditPreferenceModal(preference, false);
				// this.closeModal();
			} else {
				if (
					response.errors !== undefined &&
					Object.keys(response.errors).length > 0
				) {
					let textError = response.errors[0].description;
					console.log(textError);
					toastr.warning(this.props.t("preferences.reopenedWithErrors"), textError);
				}
			}
		}
	};

	getContent = () => {
		if (this.props.loading && !this.props.employee_preferences) {
			return <Loading />;
		}

		if (!this.props.employee_preferences) {
			return this.props.t("preferences.errorLoading");
		}

		return (
			<MyPreferences
				handleCancelRequest={this.handleCancelRequest}
				handleReopenRequest={this.handleReopenRequest}
				openEditPreferenceModal={this.openEditPreferenceModal}
			/>
		);
	};

	render() {
		const { select_employees } = this.props;

		return (
			<>
				<Layout className="page-absences page-employee" context="absences">
					<div className="heading">
						<h1 className="title">{this.props.t("preferences.myTitle")}</h1>

						<div className="heading-actions">
							<button
								type="button"
								className="btn btn-primary mr10"
								onClick={this.openNewPreferenceModal}
							>
								<FiRefreshCcw className="mr5" />
								{this.props.t("preferences.requestShift")}
							</button>
						</div>
					</div>
					<PlanNavigationTabs />
					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		...reducers.workflowsReducer,
		...reducers.employeesReducer,
		...reducers.plansReducer,
		user: reducers.authReducer.user,
		loading: reducers.workflowsReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getEmployeePreferences: (employee_id) =>
		dispatch(employeesActions.getEmployeePreferences(employee_id)),
	getPendingPreferences: (options) =>
		dispatch(workflowsActions.getPendingPreferences(options)),
	getManagedPreferences: (options) =>
		dispatch(workflowsActions.getManagedPreferences(options)),

	getSelectableEmployees: (options) =>
		dispatch(employeesActions.getSelectableEmployees(options)),
	getAttendanceShifts: () => dispatch(shiftsActions.getAttendanceShifts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Preferences));
